import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';
import { authenticatePublishingWallet } from './digitalAssetsClient';

let listEvents;
let usageAnalytics;
export async function loadAdminActivityEvents(wallet, cursor = null) {
    await authenticatePublishingWallet(wallet);
    if (!listEvents) listEvents = httpsCallable(functions, 'listActivityEvents');
    return (await listEvents({ cursor })).data;
}
export async function loadAdminUsageEvents(wallet, payload = {}, { isCurrent = () => true } = {}) {
    const walletUid = await authenticatePublishingWallet(wallet, { isCurrent });
    if (!isCurrent()) throw new Error('Wallet changed. Please retry.');
    if (!usageAnalytics) usageAnalytics = httpsCallable(functions, 'usageAnalytics');
    const result = (await usageAnalytics({ ...payload, action: 'list', walletUid })).data;
    if (!isCurrent()) throw new Error('Wallet changed. Please retry.');
    return result;
}
